import { useStore } from '@ui/hooks/useStore';

const useHeaderAuth = () => {
    const { lang } = useStore();

    return {
        lang,
    };
};

export default useHeaderAuth;
